<template>
<div class="gateway-manage-container">
  <CardList :API="API"></CardList>
</div>
</template>

<script>
import CardList from '@/components/cardList'
import CardContent from './components/card-content'
import GatewayHeader from './components/header'
import GatewayFilter from './components/filter'
import GatewayOperators from './components/operators'

import { getTenantGateway } from '@/api/device-controller'
import { gatewayParser } from '@/utils/APIParser'
import { filterGateway } from './utils/filterGateway'

export default {
  name: 'gatewayManageV2',
  components: {
    CardList
  },
  data () {
    return {
      API: {
        loading: false,
        async getData () {
          this.loading = true
          const resp = await getTenantGateway()
          this.origList = await gatewayParser(resp)
          this.filter.filter(this.origList)
          this.loading = false
        },
        origList: [],
        filter: {
          component: GatewayFilter,
          filter (origList) {
            this.filteredList = []
            setTimeout(() => {
              this.filteredList = filterGateway(origList, this.filterData)
            })
          },
          filterData: {
            name: '',
            status: null
          },
          filteredList: []
        },
        operators: {
          component: GatewayOperators
        },
        card: {
          header: {
            component: GatewayHeader
          },
          content: {
            component: CardContent
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.gateway-manage-container {
  padding: 20px;
  height: 100%;
  overflow-x: hidden;
}
</style>
